import i18n from '../i18nService';
import { recipeNamesService } from './recipeNamesService';

export const recipeNameService = {
    getLocalization(localeCode, recipe, withCodeReplace, i18nInstance = i18n) {
        return recipeNamesService.getLocalization(localeCode, recipe, withCodeReplace, i18nInstance);
    },
    getPlaceholder(i18nInstance = i18n) {
        return recipeNamesService.getPlaceholder(i18nInstance);
    },
};
